require('./bootstrap');
require('./admin-notifications');

(() => {
    document.addEventListener('DOMContentLoaded', () => {
        const sidebar = document.getElementById('adminSidebar');
        const toggle = document.querySelector('[data-admin-sidebar-toggle]');
        const storageKey = document.querySelector('meta[name="admin-sidebar-storage-key"]')?.content;

        if (!sidebar || !toggle || !storageKey) {
            return;
        }

        let prefersCollapsed = document.documentElement.classList.contains('admin-sidebar-is-collapsed');
        let isHoverExpanded = false;

        const renderCollapsed = (collapsed, hoverExpanded = false) => {
            document.documentElement.classList.toggle('admin-sidebar-is-collapsed', collapsed);
            document.body.classList.toggle('admin-sidebar-collapsed', collapsed);
            toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');

            const toggleLabel = hoverExpanded
                ? 'Mantieni menu aperto'
                : (collapsed ? 'Espandi menu' : 'Comprimi menu');
            toggle.setAttribute('aria-label', toggleLabel);
            toggle.setAttribute('title', toggleLabel);

            const icon = toggle.querySelector('i');
            if (icon) {
                icon.classList.toggle('bi-chevron-left', !collapsed && !hoverExpanded);
                icon.classList.toggle('bi-chevron-right', collapsed);
                icon.classList.toggle('bi-pin-angle', hoverExpanded);
            }
        };

        const setCollapsed = (collapsed) => {
            prefersCollapsed = collapsed;
            isHoverExpanded = false;
            renderCollapsed(collapsed);

            try {
                window.localStorage.setItem(storageKey, collapsed ? 'true' : 'false');
            } catch (error) {
                // The preference is optional; navigation remains fully functional.
            }
        };

        renderCollapsed(prefersCollapsed);

        sidebar.addEventListener('mouseenter', () => {
            if (!prefersCollapsed) {
                return;
            }

            isHoverExpanded = true;
            renderCollapsed(false, true);
        });

        sidebar.addEventListener('mouseleave', () => {
            if (!isHoverExpanded) {
                return;
            }

            isHoverExpanded = false;
            renderCollapsed(prefersCollapsed);
        });

        toggle.addEventListener('click', () => {
            setCollapsed(isHoverExpanded ? false : !prefersCollapsed);
        });
    });
})();

(() => {
    const GROUP_SELECTOR = '.admin-sidebar-group, .admin-mobile-nav-group';
    const CONTENT_SELECTOR = '.admin-sidebar-subnav, .admin-mobile-subnav';
    const ANIMATION_DURATION = 180;

    document.addEventListener('DOMContentLoaded', () => {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const runningAnimations = new WeakMap();

        const contentFor = (group) => Array.from(group.children)
            .find((child) => child.matches(CONTENT_SELECTOR));

        const finish = (group, content, expanded, animation = null) => {
            if (animation && runningAnimations.get(group) !== animation) {
                return;
            }

            runningAnimations.delete(group);
            group.classList.remove('is-opening', 'is-closing');
            group.open = expanded;
            content.style.removeProperty('overflow');
            content.style.removeProperty('will-change');
        };

        const animateGroup = (group, expanded) => {
            const content = contentFor(group);
            if (!content) {
                group.open = expanded;
                return;
            }

            const wasOpen = group.open;
            const runningAnimation = runningAnimations.get(group);
            const currentHeight = wasOpen ? content.getBoundingClientRect().height : 0;
            const currentOpacity = wasOpen
                ? Number.parseFloat(window.getComputedStyle(content).opacity) || 1
                : 0;

            if (runningAnimation) {
                runningAnimation.cancel();
                runningAnimations.delete(group);
            }

            if (expanded) {
                group.open = true;
            }

            group.classList.toggle('is-opening', expanded);
            group.classList.toggle('is-closing', !expanded);

            const targetHeight = expanded ? content.scrollHeight : 0;
            const targetOpacity = expanded ? 1 : 0;

            if (prefersReducedMotion || typeof content.animate !== 'function') {
                finish(group, content, expanded);
                return;
            }

            content.style.overflow = 'hidden';
            content.style.willChange = 'height, opacity';

            const animation = content.animate([
                {
                    height: `${currentHeight}px`,
                    opacity: currentOpacity,
                },
                {
                    height: `${targetHeight}px`,
                    opacity: targetOpacity,
                },
            ], {
                duration: ANIMATION_DURATION,
                easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
            });

            runningAnimations.set(group, animation);
            animation.addEventListener('finish', () => finish(group, content, expanded, animation), { once: true });
        };

        document.querySelectorAll(GROUP_SELECTOR).forEach((group) => {
            const summary = group.querySelector(':scope > summary');
            if (!summary) {
                return;
            }

            summary.addEventListener('click', (event) => {
                event.preventDefault();

                const isDesktopGroup = group.classList.contains('admin-sidebar-group');
                const sidebarWasCollapsed = isDesktopGroup
                    && document.body.classList.contains('admin-sidebar-collapsed');

                if (sidebarWasCollapsed) {
                    document.querySelector('[data-admin-sidebar-toggle]')?.click();
                }

                const isClosing = group.classList.contains('is-closing');
                const shouldOpen = sidebarWasCollapsed || !group.open || isClosing;

                if (!shouldOpen) {
                    animateGroup(group, false);
                    return;
                }

                const navigation = group.closest('.admin-sidebar-nav, .admin-mobile-nav');
                navigation?.querySelectorAll(GROUP_SELECTOR).forEach((otherGroup) => {
                    if (otherGroup !== group && otherGroup.open) {
                        animateGroup(otherGroup, false);
                    }
                });

                if (!group.open || isClosing) {
                    animateGroup(group, true);
                }

                if (sidebarWasCollapsed) {
                    window.requestAnimationFrame(() => summary.focus());
                }
            });
        });
    });
})();

(() => {
    const TEXT_INPUT_TYPES = new Set([
        '',
        'email',
        'number',
        'search',
        'tel',
        'text',
        'url',
    ]);
    const CLEARABLE_FILTER_INPUT_TYPES = new Set([
        ...TEXT_INPUT_TYPES,
        'date',
        'datetime-local',
        'month',
        'time',
        'week',
    ]);
    const IGNORED_INPUT_TYPES = new Set([
        'button',
        'file',
        'image',
        'reset',
        'submit',
    ]);
    const TEXT_FILTER_DELAY = 550;
    const FILTER_RESET_SELECTOR = '[data-filter-reset-target]';
    let generatedFilterControlId = 0;

    const normalizeButtonText = (button) => (
        button.value || button.textContent || ''
    ).trim().toLowerCase();

    const isGetForm = (form) => (form.getAttribute('method') || 'get').toLowerCase() === 'get';

    const hasFilterSubmit = (form) => Array.from(
        form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])')
    ).some((button) => normalizeButtonText(button).includes('filtra'));

    const hasFilterAction = (form) => Array.from(
        form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])')
    ).some((button) => {
        const text = normalizeButtonText(button);

        return text.includes('filtra')
            || text.includes('filtri')
            || text.includes('aggiorna destinatari');
    });

    const isSupportedControl = (control) => {
        if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement || control instanceof HTMLTextAreaElement)) {
            return false;
        }

        if (control.disabled || control.matches('[data-auto-filter-ignore]')) {
            return false;
        }

        return !(control instanceof HTMLInputElement && IGNORED_INPUT_TYPES.has(control.type));
    };

    const isTextFilterControl = (control) => (
        control instanceof HTMLTextAreaElement
        || (control instanceof HTMLInputElement && TEXT_INPUT_TYPES.has(control.type))
    );

    const isSuggesterControl = (control) => (
        control instanceof HTMLInputElement
        && control.matches('[data-filter-suggester], [data-auto-filter-suggester], [data-driver-search-input]')
    );

    const selectedSuggesterTargets = (control) => {
        const targetIds = (
            control.dataset.autoFilterSuggesterTarget
            || control.dataset.filterSuggesterTarget
            || ''
        ).split(/\s+/).filter(Boolean);

        if (targetIds.length) {
            return targetIds.map((id) => document.getElementById(id)).filter(Boolean);
        }

        const driverSearch = control.closest('[data-driver-search]');
        const driverHidden = driverSearch ? driverSearch.querySelector('[data-driver-search-hidden]') : null;

        return driverHidden ? [driverHidden] : [];
    };

    const hasSelectedSuggesterValue = (control) => {
        const targets = selectedSuggesterTargets(control);

        if (!targets.length) {
            return String(control.value || '').trim() !== '';
        }

        return targets.every((target) => String(target.value || '').trim() !== '');
    };

    const shouldSubmitWhileTyping = (control) => (
        Boolean(control.name)
        || control.dataset.autoFilterInput === 'on'
    );

    const textFilterDelayFor = (control, form) => {
        const configuredDelay = Number.parseInt(
            control.dataset.autoFilterDelay || form.dataset.autoFilterDelay || '',
            10
        );

        return Number.isFinite(configuredDelay) && configuredDelay >= 0
            ? configuredDelay
            : TEXT_FILTER_DELAY;
    };

    const isOptionTrigger = (element) => {
        if (!(element instanceof Element)) {
            return false;
        }

        return Boolean(element.closest('[data-auto-filter-trigger], [role="option"]'));
    };

    const isComboboxTrigger = (element) => {
        if (!(element instanceof Element)) {
            return false;
        }

        return Boolean(element.closest('[role="combobox"]'));
    };

    const submitFilterForm = (form) => {
        if (form.dataset.autoFilterSubmitting === '1') {
            return;
        }

        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
            return;
        }

        form.dataset.autoFilterSubmitting = '1';
        form.setAttribute('aria-busy', 'true');
        form.submit();
    };

    const cssEscape = (value) => {
        if (window.CSS && typeof window.CSS.escape === 'function') {
            return window.CSS.escape(value);
        }

        return String(value).replace(/[^A-Za-z0-9_-]/g, '\\$&');
    };

    const ensureControlId = (control) => {
        if (control.id) {
            return control.id;
        }

        generatedFilterControlId += 1;
        control.id = `admin_filter_control_${generatedFilterControlId}`;

        return control.id;
    };

    const resolveResetControl = (form, reference) => {
        if (!reference) {
            return null;
        }

        const byId = document.getElementById(reference);
        if (byId && (!form || form.contains(byId))) {
            return byId;
        }

        if (!form || !form.elements) {
            return null;
        }

        const byName = form.elements[reference];
        if (byName instanceof Element) {
            return byName;
        }

        if (byName && byName.length) {
            return Array.from(byName).find((control) => control instanceof Element) || null;
        }

        return null;
    };

    const fieldContainerFor = (control) => (
        control.closest('[data-driver-search], .mb-3, .mb-4, .form-group, .col, [class*="col-"]')
        || control.parentElement
    );

    const relatedResetControlsFor = (control, form) => {
        const explicitReferences = (control.dataset.filterResetRelated || '')
            .split(/\s+/)
            .filter(Boolean);
        const explicitControls = explicitReferences
            .map((reference) => resolveResetControl(form, reference))
            .filter(Boolean);

        if (explicitControls.length) {
            return explicitControls;
        }

        const driverSearch = control.closest('[data-driver-search]');
        const driverHidden = driverSearch?.querySelector('[data-driver-search-hidden]');
        if (driverHidden && driverHidden !== control) {
            return [driverHidden];
        }

        const container = fieldContainerFor(control);
        if (!container) {
            return [];
        }

        const hiddenControls = Array.from(container.querySelectorAll('input[type="hidden"][name]'))
            .filter((hiddenControl) => hiddenControl !== control);

        if (!hiddenControls.length) {
            return [];
        }

        if (!control.name) {
            return hiddenControls;
        }

        return hiddenControls.filter((hiddenControl) => (
            hiddenControl.name.startsWith(`${control.name}_`)
            || (control.id && hiddenControl.id.startsWith(`${control.id}_`))
        ));
    };

    const controlsForResetButton = (button) => {
        const form = button.form || button.closest('form');
        const references = [
            button.dataset.filterResetTarget || '',
            ...(button.dataset.filterResetRelated || '').split(/\s+/),
        ].filter(Boolean);

        return references
            .map((reference) => resolveResetControl(form, reference))
            .filter(Boolean);
    };

    const hasControlValue = (control) => {
        if (control instanceof HTMLSelectElement && control.multiple) {
            return Array.from(control.selectedOptions).some((option) => option.value !== '');
        }

        return String(control.value || '').trim() !== '';
    };

    const updateResetButton = (button) => {
        const controls = controlsForResetButton(button);
        const hasValue = controls.some(hasControlValue);

        button.disabled = !hasValue;
        button.classList.toggle('disabled', !hasValue);
    };

    const dispatchControlResetEvents = (control) => {
        control.dispatchEvent(new Event('input', { bubbles: true }));
        control.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const clearResetControl = (control) => {
        if (control instanceof HTMLSelectElement) {
            Array.from(control.options).forEach((option) => {
                option.selected = false;
            });

            if (!control.multiple) {
                control.selectedIndex = 0;
            }
        } else {
            control.value = '';
        }

        dispatchControlResetEvents(control);
    };

    const labelForControl = (control) => {
        const label = control.id
            ? document.querySelector(`label[for="${cssEscape(control.id)}"]`)
            : null;

        return (label?.textContent || control.getAttribute('aria-label') || control.placeholder || 'campo')
            .trim()
            .toLowerCase();
    };

    const createResetButton = (control, relatedControls) => {
        const controlId = ensureControlId(control);
        const relatedIds = relatedControls
            .map((relatedControl) => ensureControlId(relatedControl))
            .filter(Boolean);
        const button = document.createElement('button');
        const label = labelForControl(control);

        button.type = 'button';
        button.className = 'btn btn-outline-secondary admin-filter-reset';
        button.dataset.filterResetTarget = controlId;
        if (relatedIds.length) {
            button.dataset.filterResetRelated = relatedIds.join(' ');
        }
        button.setAttribute('aria-label', `Svuota ${label}`);
        button.setAttribute('title', `Svuota ${label}`);
        button.innerHTML = '<i class="bi bi-x-lg" aria-hidden="true"></i>';

        return button;
    };

    const shouldEnhanceClearableControl = (control, form) => {
        if (!(control instanceof HTMLInputElement)) {
            return false;
        }

        if (
            control.disabled
            || control.readOnly
            || !control.classList.contains('form-control')
            || !CLEARABLE_FILTER_INPUT_TYPES.has(control.type)
            || control.matches('[data-filter-reset="off"]')
            || control.closest('[data-admin-nav-search]')
            || control.closest(`[data-filter-reset-wrapper], ${FILTER_RESET_SELECTOR}`)
        ) {
            return false;
        }

        const controlId = ensureControlId(control);
        if (form.querySelector(`${FILTER_RESET_SELECTOR}[data-filter-reset-target="${cssEscape(controlId)}"]`)) {
            return false;
        }

        return Boolean(control.name || relatedResetControlsFor(control, form).length);
    };

    const insertResetButton = (control, button) => {
        const existingGroup = control.closest('.input-group');

        if (existingGroup) {
            control.insertAdjacentElement('afterend', button);
            return;
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'input-group';
        wrapper.dataset.filterResetWrapper = '1';

        control.insertAdjacentElement('beforebegin', wrapper);
        wrapper.appendChild(control);
        wrapper.appendChild(button);
    };

    const enhanceClearableFilterForm = (form) => {
        if (
            form.dataset.clearableFiltersInitialized === '1'
            || form.matches('[data-users-filter-form]')
            || form.dataset.filterReset === 'off'
            || !isGetForm(form)
        ) {
            return;
        }

        form.dataset.clearableFiltersInitialized = '1';

        Array.from(form.querySelectorAll('input.form-control')).forEach((control) => {
            if (!shouldEnhanceClearableControl(control, form)) {
                return;
            }

            const relatedControls = relatedResetControlsFor(control, form);
            const resetButton = createResetButton(control, relatedControls);

            insertResetButton(control, resetButton);

            const driverSearch = control.closest('[data-driver-search]');
            if (driverSearch) {
                driverSearch.classList.add('driver-filter-field--clearable');
            }
        });
    };

    const initFilterResetButton = (button) => {
        if (
            button.dataset.filterResetInitialized === '1'
            || button.closest('[data-users-filter-form]')
        ) {
            return;
        }

        button.dataset.filterResetInitialized = '1';

        const form = button.form || button.closest('form');
        const syncButton = () => updateResetButton(button);

        button.addEventListener('click', (event) => {
            event.preventDefault();

            const controls = controlsForResetButton(button);
            controls.forEach(clearResetControl);
            syncButton();

            const firstVisibleControl = controls.find((control) => control.type !== 'hidden');
            if (firstVisibleControl && typeof firstVisibleControl.focus === 'function') {
                firstVisibleControl.focus({ preventScroll: true });
            }

            if (!form || !isGetForm(form) || form.dataset.autoFilter === 'off') {
                return;
            }

            if (form.dataset.autoFilterInitialized === '1') {
                form.dispatchEvent(new CustomEvent('admin:filter-reset'));
                return;
            }

            if (hasFilterAction(form) || form.dataset.autoFilter === 'on') {
                submitFilterForm(form);
            }
        });

        controlsForResetButton(button).forEach((control) => {
            control.addEventListener('input', syncButton);
            control.addEventListener('change', syncButton);
        });

        syncButton();
    };

    const initFilterResetControls = (form) => {
        enhanceClearableFilterForm(form);
        form.querySelectorAll(FILTER_RESET_SELECTOR).forEach(initFilterResetButton);
    };

    const initAutoFilterForm = (form) => {
        if (
            form.dataset.autoFilterInitialized === '1'
            || form.dataset.autoFilter === 'off'
            || !isGetForm(form)
            || (form.dataset.autoFilter !== 'on' && !hasFilterSubmit(form))
        ) {
            return;
        }

        form.dataset.autoFilterInitialized = '1';

        let timeoutId = null;

        const scheduleSubmit = (delay = 0) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => submitFilterForm(form), delay);
        };

        form.addEventListener('input', (event) => {
            const control = event.target;

            if (
                !isSupportedControl(control)
                || isSuggesterControl(control)
                || !isTextFilterControl(control)
                || !shouldSubmitWhileTyping(control)
            ) {
                return;
            }

            scheduleSubmit(textFilterDelayFor(control, form));
        });

        form.addEventListener('change', (event) => {
            const control = event.target;

            if (!isSupportedControl(control)) {
                return;
            }

            if (isSuggesterControl(control) && !hasSelectedSuggesterValue(control)) {
                return;
            }

            scheduleSubmit();
        });

        form.addEventListener('click', (event) => {
            if (!isOptionTrigger(event.target)) {
                return;
            }

            scheduleSubmit();
        });

        form.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') {
                return;
            }

            window.setTimeout(() => {
                if (event.defaultPrevented && isComboboxTrigger(event.target)) {
                    scheduleSubmit();
                }
            }, 0);
        });

        form.addEventListener('admin:filter-reset', () => {
            scheduleSubmit();
        });

        form.addEventListener('invalid', () => {
            form.dataset.autoFilterSubmitting = '0';
            form.removeAttribute('aria-busy');
        }, true);

        form.addEventListener('submit', (event) => {
            if (event.defaultPrevented) {
                return;
            }

            if (isSuggesterControl(document.activeElement) && !hasSelectedSuggesterValue(document.activeElement)) {
                event.preventDefault();
                window.clearTimeout(timeoutId);
                form.dataset.autoFilterSubmitting = '0';
                form.removeAttribute('aria-busy');
                return;
            }

            window.clearTimeout(timeoutId);
            form.dataset.autoFilterSubmitting = '1';
            form.setAttribute('aria-busy', 'true');
        });
    };

    const initDriverSearchField = (container) => {
        if (container.dataset.driverSearchInitialized === '1') {
            return;
        }

        const searchInput = container.querySelector('[data-driver-search-input]');
        const hiddenInput = container.querySelector('[data-driver-search-hidden]');
        const suggestionsList = container.querySelector('[data-driver-search-suggestions]');

        if (!searchInput || !hiddenInput || !suggestionsList) {
            return;
        }

        container.dataset.driverSearchInitialized = '1';

        const options = Array.from(suggestionsList.querySelectorAll('[data-driver-option]'));
        const emptyState = suggestionsList.querySelector('[data-driver-empty]');
        const maxVisibleOptions = 8;
        let activeIndex = -1;

        const normalize = (value) => String(value || '').trim().toLowerCase();
        const optionValue = (option) => option.dataset.value || '';
        const optionSearchText = (option) => normalize(`${option.dataset.search || ''} ${optionValue(option)}`);
        const visibleOptions = () => options.filter((option) => !option.hidden);

        const clearActiveOption = () => {
            activeIndex = -1;
            searchInput.removeAttribute('aria-activedescendant');
            options.forEach((option) => {
                option.classList.remove('is-active');
                option.setAttribute('aria-selected', 'false');
            });
        };

        const setExpanded = (expanded) => {
            suggestionsList.hidden = !expanded;
            searchInput.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        };

        const setActiveOption = (index) => {
            const currentOptions = visibleOptions();

            clearActiveOption();

            if (!currentOptions.length) {
                return;
            }

            activeIndex = (index + currentOptions.length) % currentOptions.length;
            const activeOption = currentOptions[activeIndex];
            activeOption.classList.add('is-active');
            activeOption.setAttribute('aria-selected', 'true');
            searchInput.setAttribute('aria-activedescendant', activeOption.id);
            activeOption.scrollIntoView({ block: 'nearest' });
        };

        const matchingOptions = (value) => {
            const normalizedValue = normalize(value);
            if (normalizedValue === '') {
                return [];
            }

            const numericMatch = normalizedValue.match(/^#?(\d+)\s*$/);

            if (numericMatch) {
                return options.filter((option) => option.dataset.id === numericMatch[1]);
            }

            return options.filter((option) => optionSearchText(option).includes(normalizedValue));
        };

        const resolveOption = (value, { allowUniqueMatch = false } = {}) => {
            const normalizedValue = normalize(value);
            const numericMatch = normalizedValue.match(/^#?(\d+)\s*$/);

            if (numericMatch) {
                return options.find((option) => option.dataset.id === numericMatch[1]) || null;
            }

            const exactMatch = options.find((option) => normalize(optionValue(option)) === normalizedValue) || null;
            if (exactMatch || !allowUniqueMatch) {
                return exactMatch;
            }

            const matches = matchingOptions(value);
            return matches.length === 1 ? matches[0] : null;
        };

        const syncHiddenId = ({ allowUniqueMatch = false, updateSearchValue = false } = {}) => {
            const option = resolveOption(searchInput.value, { allowUniqueMatch });

            hiddenInput.value = option?.dataset.id || '';

            if (option && updateSearchValue) {
                searchInput.value = optionValue(option);
            }
        };

        const renderSuggestions = () => {
            const query = normalize(searchInput.value);
            let shownOptions = 0;

            options.forEach((option) => {
                const matches = query === '' || optionSearchText(option).includes(query);
                const shouldShow = matches && shownOptions < maxVisibleOptions;

                option.hidden = !shouldShow;

                if (shouldShow) {
                    shownOptions += 1;
                }
            });

            if (emptyState) {
                emptyState.hidden = shownOptions > 0;
            }

            clearActiveOption();
            setExpanded(document.activeElement === searchInput && (shownOptions > 0 || Boolean(emptyState && !emptyState.hidden)));
        };

        const selectOption = (option) => {
            if (!option) {
                return;
            }

            searchInput.value = optionValue(option);
            hiddenInput.value = option.dataset.id || '';
            clearActiveOption();
            setExpanded(false);
        };

        options.forEach((option) => {
            option.addEventListener('click', () => selectOption(option));
        });

        suggestionsList.addEventListener('mousedown', (event) => {
            event.preventDefault();
        });

        searchInput.addEventListener('focus', renderSuggestions);
        searchInput.addEventListener('input', () => {
            syncHiddenId();
            renderSuggestions();
        });
        searchInput.addEventListener('change', () => syncHiddenId({ allowUniqueMatch: true, updateSearchValue: true }));
        searchInput.addEventListener('blur', () => {
            syncHiddenId({ allowUniqueMatch: true, updateSearchValue: true });
            window.setTimeout(() => setExpanded(false), 100);
        });
        searchInput.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                setExpanded(false);
                return;
            }

            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();

                if (suggestionsList.hidden) {
                    renderSuggestions();
                }

                setActiveOption(activeIndex + (event.key === 'ArrowDown' ? 1 : -1));
                return;
            }

            if (event.key === 'Enter' && !suggestionsList.hidden) {
                const currentOptions = visibleOptions();
                const selectedOption = activeIndex >= 0
                    ? currentOptions[activeIndex]
                    : (currentOptions.length === 1 ? currentOptions[0] : null);

                if (selectedOption) {
                    event.preventDefault();
                    selectOption(selectedOption);
                }
            }
        });

        searchInput.form?.addEventListener('submit', () => {
            syncHiddenId({ allowUniqueMatch: true, updateSearchValue: true });
        });

        document.addEventListener('click', (event) => {
            if (!container.contains(event.target)) {
                setExpanded(false);
            }
        });

        syncHiddenId();
    };

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('form').forEach(initFilterResetControls);
        document.querySelectorAll('[data-driver-search]').forEach(initDriverSearchField);
        document.querySelectorAll('form').forEach(initAutoFilterForm);
    });
})();

(() => {
    const ROOT_SELECTOR = '[data-ticket-attachment-uploader]';

    const formatFileSize = (bytes) => {
        if (!Number.isFinite(bytes) || bytes <= 0) {
            return '0 B';
        }

        const units = ['B', 'KiB', 'MiB', 'GiB'];
        const unitIndex = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
        const value = bytes / (1024 ** unitIndex);

        return `${new Intl.NumberFormat('it-IT', {
            maximumFractionDigits: unitIndex === 0 ? 0 : 1,
        }).format(value)} ${units[unitIndex]}`;
    };

    const fileExtension = (file) => {
        const name = String(file?.name || '');
        const separatorIndex = name.lastIndexOf('.');

        return separatorIndex >= 0 ? name.slice(separatorIndex + 1).toLowerCase() : '';
    };

    const fileIdentity = (file) => [
        file.name,
        file.size,
        file.lastModified,
        file.type,
    ].join('::');

    const compactFileNames = (files) => {
        const names = files.slice(0, 3).map((file) => `“${file.name}”`);
        const remaining = files.length - names.length;

        return `${names.join(', ')}${remaining > 0 ? ` e altri ${remaining}` : ''}`;
    };

    const createDataTransfer = () => {
        if (typeof window.DataTransfer !== 'function') {
            return null;
        }

        try {
            return new window.DataTransfer();
        } catch (error) {
            return null;
        }
    };

    const initTicketAttachmentUploader = (root) => {
        if (root.dataset.ticketAttachmentUploaderInitialized === 'true') {
            return;
        }

        const input = root.querySelector('[data-ticket-attachment-input]');
        const dropzone = root.querySelector('[data-ticket-attachment-dropzone]');
        const list = root.querySelector('[data-ticket-attachment-list]');
        const summary = root.querySelector('[data-ticket-attachment-summary]');
        const clientError = root.querySelector('[data-ticket-attachment-error]');

        if (!input || !dropzone || !list || !summary || !clientError) {
            return;
        }

        root.dataset.ticketAttachmentUploaderInitialized = 'true';

        if (!createDataTransfer()) {
            input.classList.remove('visually-hidden');
            dropzone.classList.add('d-none');
            return;
        }

        const maxFiles = Number.parseInt(root.dataset.maxFiles || '10', 10);
        const maxFileSize = Number.parseInt(root.dataset.maxFileSize || String(10 * 1024 * 1024), 10);
        const allowedExtensions = new Set((root.dataset.allowedExtensions || '')
            .split(',')
            .map((extension) => extension.trim().toLowerCase())
            .filter(Boolean));
        let selectedFiles = Array.from(input.files || []);
        let dragDepth = 0;

        const setClientError = (messages = []) => {
            clientError.textContent = messages.join(' ');
            clientError.classList.toggle('d-none', messages.length === 0);
        };

        const syncNativeInput = () => {
            const transfer = createDataTransfer();
            if (!transfer) {
                return false;
            }

            selectedFiles.forEach((file) => transfer.items.add(file));

            try {
                input.files = transfer.files;
                return true;
            } catch (error) {
                setClientError(['Il browser non consente di mantenere selezioni multiple. Seleziona tutti i file in un unico passaggio.']);
                return false;
            }
        };

        const renderFiles = () => {
            list.replaceChildren();
            list.classList.toggle('d-none', selectedFiles.length === 0);

            const totalSize = selectedFiles.reduce((total, file) => total + file.size, 0);
            if (selectedFiles.length === 0) {
                summary.textContent = 'Nessun file selezionato.';
            } else {
                const fileLabel = selectedFiles.length === 1 ? 'file pronto' : 'file pronti';
                const remaining = Math.max(maxFiles - selectedFiles.length, 0);
                summary.textContent = `${selectedFiles.length} ${fileLabel} per il caricamento · ${formatFileSize(totalSize)}${remaining > 0 ? ` · puoi aggiungerne ancora ${remaining}` : ' · limite raggiunto'}.`;
            }

            selectedFiles.forEach((file, index) => {
                const row = document.createElement('div');
                row.className = 'ticket-attachment-file d-flex align-items-center gap-3';

                const icon = document.createElement('i');
                icon.className = 'bi bi-paperclip ticket-attachment-file-icon flex-shrink-0';
                icon.setAttribute('aria-hidden', 'true');

                const details = document.createElement('div');
                details.className = 'min-w-0 flex-grow-1';

                const name = document.createElement('div');
                name.className = 'fw-semibold text-break';
                name.textContent = file.name;

                const size = document.createElement('div');
                size.className = 'small text-muted';
                size.textContent = formatFileSize(file.size);

                const removeButton = document.createElement('button');
                removeButton.type = 'button';
                removeButton.className = 'btn btn-sm btn-outline-danger flex-shrink-0';
                removeButton.dataset.ticketAttachmentRemove = String(index);
                removeButton.setAttribute('aria-label', `Rimuovi ${file.name}`);

                const removeIcon = document.createElement('i');
                removeIcon.className = 'bi bi-x-lg';
                removeIcon.setAttribute('aria-hidden', 'true');

                details.append(name, size);
                removeButton.appendChild(removeIcon);
                row.append(icon, details, removeButton);
                list.appendChild(row);
            });
        };

        const addFiles = (incomingFiles) => {
            const incoming = Array.from(incomingFiles || []);
            const oversized = [];
            const invalidType = [];
            const duplicates = [];
            const overLimit = [];
            const knownFiles = new Set(selectedFiles.map(fileIdentity));

            incoming.forEach((file) => {
                if (file.size > maxFileSize) {
                    oversized.push(file);
                    return;
                }

                if (allowedExtensions.size > 0 && !allowedExtensions.has(fileExtension(file))) {
                    invalidType.push(file);
                    return;
                }

                const identity = fileIdentity(file);
                if (knownFiles.has(identity)) {
                    duplicates.push(file);
                    return;
                }

                if (selectedFiles.length >= maxFiles) {
                    overLimit.push(file);
                    return;
                }

                knownFiles.add(identity);
                selectedFiles.push(file);
            });

            const messages = [];
            if (oversized.length > 0) {
                messages.push(`Superano ${formatFileSize(maxFileSize)}: ${compactFileNames(oversized)}.`);
            }
            if (invalidType.length > 0) {
                messages.push(`Formato non consentito: ${compactFileNames(invalidType)}.`);
            }
            if (duplicates.length > 0) {
                messages.push(`Già presenti: ${compactFileNames(duplicates)}.`);
            }
            if (overLimit.length > 0) {
                messages.push(`Puoi caricare al massimo ${maxFiles} file; ${overLimit.length} non ${overLimit.length === 1 ? 'è stato aggiunto' : 'sono stati aggiunti'}.`);
            }

            setClientError(messages);
            syncNativeInput();
            renderFiles();
        };

        input.addEventListener('change', () => addFiles(input.files));

        dropzone.addEventListener('click', () => {
            if (!input.disabled) {
                input.click();
            }
        });

        dropzone.addEventListener('keydown', (event) => {
            if ((event.key === 'Enter' || event.key === ' ') && !input.disabled) {
                event.preventDefault();
                input.click();
            }
        });

        dropzone.addEventListener('dragenter', (event) => {
            event.preventDefault();
            dragDepth += 1;
            dropzone.classList.add('is-dragging');
        });

        dropzone.addEventListener('dragover', (event) => {
            event.preventDefault();
            if (event.dataTransfer) {
                event.dataTransfer.dropEffect = 'copy';
            }
        });

        dropzone.addEventListener('dragleave', (event) => {
            event.preventDefault();
            dragDepth = Math.max(dragDepth - 1, 0);
            if (dragDepth === 0) {
                dropzone.classList.remove('is-dragging');
            }
        });

        dropzone.addEventListener('drop', (event) => {
            event.preventDefault();
            dragDepth = 0;
            dropzone.classList.remove('is-dragging');
            addFiles(event.dataTransfer?.files || []);
        });

        list.addEventListener('click', (event) => {
            if (!(event.target instanceof Element)) {
                return;
            }

            const button = event.target.closest('[data-ticket-attachment-remove]');
            if (!button) {
                return;
            }

            const index = Number.parseInt(button.dataset.ticketAttachmentRemove || '', 10);
            if (!Number.isInteger(index) || index < 0 || index >= selectedFiles.length) {
                return;
            }

            selectedFiles.splice(index, 1);
            setClientError([]);
            syncNativeInput();
            renderFiles();
            dropzone.focus();
        });

        input.form?.addEventListener('reset', () => {
            window.setTimeout(() => {
                selectedFiles = [];
                setClientError([]);
                syncNativeInput();
                renderFiles();
            }, 0);
        });

        syncNativeInput();
        renderFiles();
    };

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll(ROOT_SELECTOR).forEach(initTicketAttachmentUploader);
    });
})();
